export default __webpack_public_path__ + "static/media/replit.1df60403.svg";